import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EnumRefPipe } from 'src/app/shared/pipes/enum-ref.pipe';
import { SelectedSourceDataPipe } from 'src/app/shared/pipes/selected-source-data.pipe';
import { UnitDetail } from '../../interface/property.interface';

export interface RemoveUnitsDialogData {
  units: UnitDetail[];
  removalCount: number;
  propertySubType: string;
}

@Component({
  selector: 'app-remove-units-dialog',
  standalone: true,
  imports: [MatButtonModule, MatCheckboxModule, MatDialogModule, EnumRefPipe, SelectedSourceDataPipe],
  templateUrl: './remove-units-dialog.component.html',
  styleUrls: ['./remove-units-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveUnitsDialogComponent {
  /** When every unit must be removed, the selection is locked. */
  readonly isFullRemoval: boolean;
  readonly selectedUnitIds = new Set<number>();

  constructor(
    public dialogRef: MatDialogRef<RemoveUnitsDialogComponent, number[]>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveUnitsDialogData
  ) {
    dialogRef.disableClose = true;
    this.isFullRemoval = data.removalCount >= data.units.length;

    if (this.isFullRemoval) {
      data.units.forEach((unit) => this.selectedUnitIds.add(unit.id));
    }
  }

  toggleUnit(unitId: number, checked: boolean): void {
    if (this.isFullRemoval) return;

    if (checked) {
      this.selectedUnitIds.add(unitId);
    } else {
      this.selectedUnitIds.delete(unitId);
    }
  }

  confirm(): void {
    if (!this.canConfirm) return;
    this.dialogRef.close([...this.selectedUnitIds]);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  get canConfirm(): boolean {
    return this.selectedUnitIds.size === this.data.removalCount;
  }
}
